import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LinkContext } from "../LinkProvider";
import { useContext } from "react";


function MobileMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const { t } = useTranslation();
  const { link } = useContext(LinkContext);
  const toggleMenu = () => {
    setIsOpen((prev) => !prev);
  };

  // 🚫 Блокировка прокрутки body при открытом меню
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    // Очистка на случай размонтирования
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  return (
    <div>
      <div
        className="relative z-[999] w-[30px] h-[25px] cursor-pointer flex flex-col justify-between xl:hidden"
        onClick={toggleMenu}
      >
        <div
          className={`w-full h-[1px] transition duration-300 transform ${
            isOpen
              ? "rotate-45 translate-y-[9px] bg-[#000] w-[35px]"
              : "bg-[#000]"
          }`}
        ></div>
        <div
          className={`w-full h-[1px] bg-[#000] transition duration-300 transform ${
            isOpen ? "hidden" : "block"
          }`}
        ></div>
        <div
          className={`w-full h-[1px] transition duration-300 transform ${
            isOpen
              ? "-rotate-45 -translate-y-[15px] bg-[#000] w-[35px]"
              : "bg-[#000]"
          }`}
        ></div>
      </div>

      {/* Меню */}
      <div
        className={`fixed top-0 right-0 bottom-0 w-2/3 bg-white z-[500] transform transition-all duration-300 ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex flex-col items-center mt-[100px] gap-[15px]">
          <Link to="/trading">
            <p
              className={`text-[18px] roboto ${
                location.pathname === "/trading" ? "font-bold" : "font-medium"
              }`}
              onClick={toggleMenu}
            >
              {t("header.1")}
            </p>
          </Link>
          <Link to="/sponsor">
            <p
              className={`text-[18px] roboto ${
                location.pathname === "/sponsor" ? "font-bold" : "font-medium"
              }`}
              onClick={toggleMenu}
            >
              {t("header.2")}
            </p>
          </Link>
          <Link to="/account">
            <p
              className={`text-[18px] roboto ${
                location.pathname === "/account" ? "font-bold" : "font-medium"
              }`}
              onClick={toggleMenu}
            >
              {t("header.3")}
            </p>
          </Link>
          <Link to="/partner">
            <p
              className={`text-[18px] roboto ${
                location.pathname === "/partner" ? "font-bold" : "font-medium"
              }`}
              onClick={toggleMenu}
            >
              {t("header.4")}
            </p>
          </Link>
          <Link to="/aboutus">
            <p
              className={`text-[18px] roboto ${
                location.pathname === "/aboutus" ? "font-bold" : "font-medium"
              }`}
              onClick={toggleMenu}
            >
              {t("header.5")}
            </p>
          </Link>

          <a href={link}>
            <div className="cursor-pointer border border-[#131313] hover:py-[5px] transition-all py-[8px] px-[20px] rounded-[60px]">
              <p className="roboto text-[#131313] text-[16px]">
                {t("header.button")}
              </p>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
}

export default MobileMenu;
